import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { MmuUserType } from '../../auth/models';
import { MmuUserService } from '../../auth/user-service/mmu-user.service';
import { MmuLogger } from '../../logging';


/**
 * Internal user route guard factory for Miele MOVE. Check if the user is flagged as internal.
 *
 * @param type The user type that is allowed to access the route.
 * @returns {CanActivateFn | CanActivateChildFn}
 *
 * @example ```typescript
 * {
 *   path: 'protected',
 *   component: ProtectedComponent,
 *   canActivate: [isUserType('customer')]
 * }
 * ```
 */
export function isUserType(type: MmuUserType): CanActivateFn | CanActivateChildFn {
  return (_, state) => {
    const router = inject(Router);
    const userService = inject(MmuUserService);
    const allowNavigation = userService.user.type === type;

    if (!allowNavigation) {
      const logger = inject(MmuLogger);
      logger.warn(
        `Tried to access a protected page at "${state.url}" which is only allowed for users of type "${type}".`,
        'User type:', userService.user.type
      );

      return router.createUrlTree(['/error']);
    }

    return true;
  };
}
